import { useEffect, useState } from 'react';
import { api } from '../../api/api';
import { PageProps } from '../../routing/routing';
import { DetailedFileInfo } from '../../types/detailed-file-info';
import { Header } from '../../components/_preview/header';
import { FilePreview } from '../../components/_preview/file-preview';
import './preview.css';
import { useMount } from '../../hooks/use-mount';
import { HelpScout } from '../../services/help-scout';
import { useParentFolder } from '../../components/_folder/new-button/use-parent-folder';
import { getLoggingContextParams } from '../../services/get-logging-context-params';

export interface PreviewProps extends PageProps<{ fileId: string }> {}

export default function Preview(props: PreviewProps) {
	const [file, setFile] = useState<DetailedFileInfo | null>();
	const { fileId } = props.match.params;

	const currentFolder = useParentFolder();
	const loggingParams = getLoggingContextParams(currentFolder);

	useEffect(() => {
		api.get.file('/' + fileId).then((result) => {
			setFile(result?.file || null);
			if (result?.file?.title) {
				document.title = result.file.title;
			}
		});
	}, [fileId]);

	useMount(() => {
		const current = document.title;
		return () => {
			document.title = current;
		};
	});

	useMount(() => {
		HelpScout.close();
	});

	return (
		<div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
			<Header title={file?.title} download={file ? file.links.download + loggingParams : undefined} preview={window.location.href} />
			<div className='preview-pane'>
				<FilePreview file={file} loggingParams={loggingParams} />
			</div>
		</div>
	);
}
